module.exports = __webpack_public_path__ + "img/list.cef936a0.png";